import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import * as React from 'react';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { BackgroundJobs, IBackgroundJobInfo } from '../../../../ts/resources/BackgroundJobs';
import { ModalInstance, ReactModalOptions, ReactModalService } from '../../../../ts/services/ReactModalService';
import { ToasterService, ToastType } from '../../../../ts/services/ToasterService';
import { CancelBackgroundJob, ToggleBackgroundJobExtendedInfoDialog } from '../../../actions/AppActionTypes';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { CancelBackgroundJobAction } from '../../../actions/spaces/CancelBackgroundJobAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ToggleBackgroundJobExtendedInfoDialogAction } from '../../../actions/spaces/ToggleBackgroundJobExtendedInfoDialog';
import { ServiceLocator } from '../../../ServiceLocator';
import { BackgroundJobExtendedInfoDialog } from '../../../spaces/BackgroundJobsSpace/BackgroundJobExtendedInfoDialog';

export function* openCancelDialog(content: IBackgroundJobInfo) {
  const cancelJob = () => {
    dialog.close();
    const backgroundJobs = ServiceLocator.get<BackgroundJobs>('BackgroundJobs');
    backgroundJobs
      .cancelBackgroundJob(content)
      .then(result => {
        const service = ServiceLocator.get<ToasterService>('ToasterService');
        if (result.errors && result.errors.length > 0) {
          service.pop({
            text: Messages.backgroundJobCancelFailed(),
            type: ToastType.Error,
          });
        } else {
          service.pop({
            text: Messages.backgroundJobCancelSuccessful(),
            type: ToastType.Info,
          });
        }
      });
  };
  const footerOptions = {
    buttons: [
      {
        handleClick: () => dialog.close(),
        buttonType: ButtonType.Outline,
        children: Messages.cancel(),
        testId: 'footer-cancel'
      },
      {
        handleClick: cancelJob,
        buttonType: ButtonType.Go,
        children: Messages.backgroundJobCancelDialogOk(),
        testId: 'footer-confirm'
      }
    ],
    testId: 'cance-dialog-footer',
  };
  const dialogOptions: ReactModalOptions = {
    testId: 'cancel-dialog',
    title: Messages.backgroundJobCancelDialogCancelJob(),
    type: DialogType.NormalWithTitleBar,
    showCloseButton: true,
    positioningBehavior: DialogPositioningBehavior.Centered,
    shouldReturnFocusOnClose: false,
    dialogContent: Messages.backgroundJobCancelDialogAreYouSure(),
    footerContent: React.createElement(DialogFooterButtonsWidget, footerOptions),
  };
  const dialog: ModalInstance = yield call(ReactModalService.open, dialogOptions);
  return;
}

export function* cancelBackgroundJob(action: CancelBackgroundJobAction) {
  try {
    yield call(openCancelDialog, action.backgroundJob);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.backgroundJobCancelFailed()));
  }
}

export function* toggleBackgroundJobExtendedInfoDialog(action: ToggleBackgroundJobExtendedInfoDialogAction) {
  yield call(BackgroundJobExtendedInfoDialog.toggle, action.backgroundJob);
}

export function* rootBackgroundJobSaga(): SagaIterator {
  yield takeEvery(CancelBackgroundJob, cancelBackgroundJob);
  yield takeEvery(ToggleBackgroundJobExtendedInfoDialog, toggleBackgroundJobExtendedInfoDialog);
}
